<template>
  <a-modal
    v-if="deleteVisible"
    class="custom_modal"
    v-model:visible="deleteVisible"
    :closable="false"
    :centered="true"
    :footer="null"
    :width="800"
    :onCancel="cancel"
    wrapClassName="lyric-detail-modal"
  >
    <div class="top-bg"></div>
    <div class="header">
      <div class="title">{{ detail.article.title }}</div>
      <div class="close" @click="toggleModal"></div>
    </div>
    <div class="content">
      <div v-if="detail.subtitleList?.length > 0">
        <div v-for="item in detail.subtitleList" :key="item.startTs">
          <div>{{ item.data.text }}</div>
        </div>
      </div>
      <div v-else class="empty-show">
        <img src="../imgs/empty.png" />
        <div class="title">暂无字幕</div>
        <div class="sub-title">当前音频、视频没有匹配的字幕哦，快去「听力工具」生成字幕文件吧</div>
      </div>
    </div>
    <div class="content-bg"></div>
    <div class="footer">
      <AudioPlay rlogKey="all" :src="detail.article.audioUrl">
        <div v-if="detail.subtitleList?.length > 0">
          <div :class="['goEdit']" data-rlog="all_go_hearing_edit" @click="goEdit">编辑字幕</div>
        </div>
        <div v-else :class="['goEdit', 'goEdit-hide']">
          <a-dropdown
            placement="topCenter"
            :trigger="['click']"
            overlayClassName="choose-lang-modal"
          >
            <a class="btn" data-rlog="all_make_irc" @click="e => e.preventDefault()"> 生成字幕 </a>
            <template #overlay>
              <div class="overlay-content">
                <div class="title">选择音频语言</div>
                <div
                  @click="changeType(item.value)"
                  :class="['lang-item', item.value === langType ? 'lang-item-choosed' : '']"
                  v-for="item in Object.values(langTypeConfig)"
                  :key="item.value"
                  :value="item.value"
                  :data-rlog="item.makerlogKey"
                >
                  {{ item.label }}
                </div>
              </div>
            </template>
          </a-dropdown>
        </div>
      </AudioPlay>
    </div>
  </a-modal>
  <div class="control-btn" data-rlog="all_show_lyric_preview" @click="toggleModal(true)">
    <slot></slot>
  </div>
</template>
<script>
import './LyricPreview.scss';
import { ref } from 'vue';
import { getIrcDetailData } from '../../hearingDetail/methods/api';
import AudioPlay from '../../hearingDetail/components/AudioPlay.vue';
import routeController from '@/controller/router';
import { defaultLangType, langTypeConfig } from '../../hearingDetail/config';
import { createTask } from '../../hearingTask/methods/HearingTaskList';

export default {
  props: {
    dataSource: Object,
  },
  components: { AudioPlay },
  setup(props) {
    const deleteVisible = ref(false);
    const detail = ref({ subtitleList: [], article: {} });
    const langType = ref(defaultLangType);
    const { changePage } = routeController();
    function changeType(newValue) {
      // langType.value = newValue
      const { articleKey, columnKey } = props.dataSource;
      createTask({
        langType: newValue,
        translate: 0, // 不翻译pser
        columnKey,
        articleKey,
      }).then(res => {
        if (res.code === 0) {
          changePage('/hearing/hearingTask', { activeKey: '1' });
        }
      });
    }
    function getData() {
      const { articleKey, columnKey } = props.dataSource;
      getIrcDetailData({
        articleKey,
        columnKey,
      }).then(data => {
        detail.value = data.data;
      });
    }
    function rlogClose() {
      window._rlog.push(['_trackEvent', 'all_close_lyric_preview']);
    }
    function toggleModal() {
      deleteVisible.value = !deleteVisible.value;
      if (deleteVisible.value) {
        getData();
      } else {
        rlogClose();
      }
    }
    function goEdit() {
      const { articleKey, columnKey, audioLang } = props.dataSource;
      changePage('/hearingDetail', {
        articleKey,
        columnKey,
        langType: audioLang,
      });
    }
    function cancel() {
      rlogClose();
    }
    return {
      langTypeConfig,
      langType,
      changeType,
      cancel,
      deleteVisible,
      toggleModal,
      detail,
      goEdit,
    };
  },
};
</script>
